module.exports = __webpack_public_path__ + "static/projects-teaser@2x-36ec07b401ec953b7e5f1d12cab7bb3b.jpg";